<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-03-18 10:48:11
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-07-26 15:44:08
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/nesting/jobsPromptInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="docker-server">
    <iframe
      id="iframeChild"
      ref="iframeDom"
      name="iframeChild"
      :src="getPageUrl"
      frameborder="0"
      scrolling="auto"
    >
    </iframe>
  </div>
</template>

<script>
import request from '../../api/nesting';

export default {
  name: 'JobsPromptInfo',
  data() {
    return {
      getPageUrl: '',
    };
  },
  mounted() {
    request
      .getGsnPageUrlInfo({
        gsnParam: 'jobsPromptInfo',
      })
      .then((res) => {
        if (res.status) {
          this.getPageUrl = res.data.gsnReturnUrl;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
/** iframe样式 */
#iframeChild {
  width: 100%;
  height: calc(100vh - 125px);
}
</style>
